"use strict";
var EventDelegate_1 = require('./EventDelegate');
var MutationHandler_1 = require('./MutationHandler');
var Pop_1 = require('./Pop');
var PopEngine_1 = require('./PopEngine');
var SchemaStore_1 = require('./SchemaStore');
var Trigger_1 = require('./Trigger');
var closest = require('closest');
var Popgun = (function () {
    function Popgun() {
    }
    // registers mutation observer and sets up eventListeners
    Popgun.prototype.init = function () {
        if (!document.body.hasAttribute('popgun-exists')) {
            MutationHandler_1.default.registerObserver();
            EventDelegate_1.default.init();
            document.body.setAttribute('popgun-exists', '');
        }
        else {
            throw new Error('Popgun has already been instantiated. Do not instantiate again.');
        }
    };
    // Store a group w/ options to reuse 
    // schema is a base set of options, options attr will precedence over schema
    Popgun.prototype.registerGroup = function (groupId, groupOpts) {
        PopEngine_1.default.addGroupOptionsToGroupStore(groupId, groupOpts);
    };
    // Store a schema of options
    Popgun.prototype.registerSchema = function (schemaId, opts) {
        SchemaStore_1.default.add(schemaId, opts);
    };
    Popgun.prototype.getPopFromGroupId = function (groupId) {
        return PopEngine_1.default.getPopFromGroupId(groupId);
    };
    // hidden, content_setup, pre_position, pre_show, showing, pre_hide
    Popgun.prototype.getPopState = function (pop) {
        return pop.state;
    };
    // returns whether a pop for a specific target is alrady open
    Popgun.prototype.isPopAlreadyOpenForTarget = function (target) {
        return PopEngine_1.default.isPopAlreadyOpenForTarget(target);
    };
    // returns whether a pop is already open for any group
    Popgun.prototype.isPopAlreadyOpenForGroup = function (groupId) {
        return PopEngine_1.default.isPopAlreadyOpenForGroup(groupId);
    };
    // reposition a pop based on the groupId
    Popgun.prototype.reposition = function (groupId) {
        var pop = PopEngine_1.default.getPopFromGroupId(groupId);
        if (!!pop) {
            var container = closest(pop.popOver.element, 'div[pop=""]');
            PopEngine_1.default.setPosition(pop, container);
        }
        else {
            throw new Error('No pop open for this groupId.');
        }
    };
    // Show the popover for a particular target element
    Popgun.prototype.showPop = function (target, isPinned, trigger) {
        var t = new Trigger_1.default(trigger);
        var pop = new Pop_1.default(target, t);
        PopEngine_1.default.showPop(target, isPinned, pop);
    };
    // Hide the popover for a particular target element
    Popgun.prototype.hidePop = function (target, hideFullChain) {
        PopEngine_1.default.synchronousHidePop(target, hideFullChain);
    };
    return Popgun;
}());
exports.Popgun = Popgun;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new Popgun();
